/**
 * 
 * @module gpt
 * @description simplify working with doubleclick
 * 
 */

define('doubleclick/gpt',['require','exports','module','jquery','bam.url/url','ensureArray/ensureArray','active-sponsorship/active-sponsorship'],function(require, exports, module) {

    'use strict';

    var $                   = require('jquery');
    var url                 = require('bam.url/url');
    var ensureArray         = require('ensureArray/ensureArray');
    var activeSponsorship   = require('active-sponsorship/active-sponsorship');

    // Create global googletag namespace
    window.googletag = window.googletag || {};
    window.gptadslots = window.gptadslots || {};
    window.googletag.cmd = window.googletag.cmd || [];
    window.googletag.cmd.push(function() {
        window.googletag.pubads().enableAsyncRendering();
        window.googletag.pubads().collapseEmptyDivs();
    });

    // Boilerplate asynchronously-loaded Google Publisher Tag script
    (function() {
        var useSSL = 'https:' === document.location.protocol;
        var gads = document.createElement('script');
            gads.async = true;
            gads.type = 'text/javascript';
            gads.src = (useSSL ? 'https:' : 'http:') + '//www.googletagservices.com/tag/js/gpt.js';
        var node = document.getElementsByTagName('script')[0];
            node.parentNode.insertBefore(gads, node);
    })();

    /**
     *
     * @function setTakeover
     * @param {Object} skin
     *
     */
    window.setTakeover = function(skin) {

        var bgColor = skin.bgColor || '#000000',
            bgImage = (skin.bgImage) ? 'url(' + skin.bgImage + ')' : 'none',
            bgPosition = skin.bgPosition || 'center top',
            bgRepeat = skin.bgRepeat || 'no-repeat',
            bgAttachment = skin.bgAttachment || 'scroll';

        $HTML.addClass('sponsored-takeover');

        $SKIN.css({
            'background-color': bgColor,
            'background-image': bgImage,
            'background-position': bgPosition,
            'background-repeat': bgRepeat,
            'background-attachment': bgAttachment
        });

        if (skin.clickHref) {

            var clickHref = skin.clickHref,
                clickTarget = skin.clickTarget || '_blank',
                clickHeight = skin.clickHeight || '900px',
                clickTop = skin.clickTop || '0';

            // allow one instance of the sponsored takeover anchor
            if (!$HTML.find('#sponsored-takeover-link').length) {

                $('<a></a>').attr({
                    'id': 'sponsored-takeover-link',
                    'target': clickTarget,
                    'href': clickHref
                }).css({
                    'display': 'block',
                    'position': 'absolute',
                    'z-index': '0',
                    'width': '100%',
                    'height': clickHeight,
                    'top': clickTop
                }).prependTo($SKIN);

            }

        }

        $('#sidebar-takeover-news').insertAfter($('#sidebar-takeover-ad'));

    };

    var DEFAULTS = {
        networkId: '/2605/',
        inventoryHierarchy: 'mlb.mlb/',
        skinElement: 'body',
        enableSingleRequest: false,
        responsive: false,
        thresholds: [0, 480, 670, 768, 980, 1024],
        targeting: {}
    };

    var UNITNAME,
        ADOPSTEST = url.Location().getParam('adtest'),
        $SKIN,
        $HTML = $('html'),
        $WINDOW = $(window),
        $DOCUMENT = $(document),
        $RESPONSIVESLOTS = $('.ad-responsive-slot'),
        currentThreshold;

    /**
     *
     * @method getDefaultInventoryHierachy
     * @returns {String} inventoryHierachy
     *
     */
    function getDefaultInventoryHierachy() {

        var unitname = UNITNAME,
            inventoryHierachy = unitname.split('/').slice(0, 3).join('/');

        return inventoryHierachy;

    }

    /**
     *
     * @method getThreshold
     * @param {Number} width
     *
     */
    function getThreshold(width) {

        var i = DEFAULTS.thresholds.length;

        while (i) {

            i -= 1;

            if (width > DEFAULTS.thresholds[i]) {
                return i;
            }

        }

    }

    /**
     *
     * @method groupRefresh
     * @param {Array} ads
     * @description expects an Array of Objects, updates targeting and refreshes ad
     * @note display has to be called before refresh
     *
     */
    exports.groupRefresh = function(ads) {

        var collection = ensureArray(ads),
            container,
            targeting;

        for (var i = 0; i < collection.length; i += 1) {

            container = collection[i] && collection[i].container || '';
            targeting = collection[i] && collection[i].targeting || DEFAULTS.targeting;

            if (container in window.gptadslots) {

                exports.setTargeting(container, targeting);
                exports.display(container);
                exports.refresh(container);

            }

        }

    };

    /**
     *
     * @method responsiveRefresh
     *
     */
    exports.responsiveRefresh = function() {

        var defaultTargeting = DEFAULTS.targeting;

        // iterate over each ad group
        $RESPONSIVESLOTS.each(function() {

            var $responsiveSlot = $(this);

            // Iterate through the ad size containers within, hide them all
            $responsiveSlot.find('.ad-responsive-size').hide().each(function() {

                var $responsiveSize = $(this);

                // Determine the thresholds/breakpoints this size should be displayed in
                var adThresholds = $responsiveSize.data('thresholds');
                var inThreshold = ($.inArray(currentThreshold, adThresholds) > -1);

                if (inThreshold) {

                    // Grab the Targeting params from the size and merge with the grouping's
                    var slotTargeting = $responsiveSlot.data('targeting');
                    var sizeTargeting = $responsiveSize.data('targeting');
                    var targeting = $.extend({}, defaultTargeting, slotTargeting, sizeTargeting);

                    // Grab the Container ID and Size Array for the Ad Slot
                    var container = $responsiveSize.attr('id');
                    var sizes = $responsiveSize.data('sizes');

                    // If this Ad Slot is not cached, defineSlot, setTargeting and display it
                    if (!(container in window.gptadslots)) {

                        var isOutOfPage = $responsiveSlot.hasClass('ad-outofpage');

                        if (isOutOfPage) {

                            exports.queue(function() {
                                window.gptadslots[container] = window.googletag.defineOutOfPageSlot(UNITNAME, container).addService(window.googletag.pubads());
                            });

                        } else {

                            exports.queue(function() {
                                window.gptadslots[container] = window.googletag.defineSlot(UNITNAME, sizes, container).addService(window.googletag.pubads());
                            });

                        }

                        if (!$.isEmptyObject(targeting)) {
                            exports.setTargeting(container, targeting);
                        }

                        exports.display(container);

                    // ad already exists in cache, update the targeting
                    // and refresh the slot
                    } else {

                        if (!$.isEmptyObject(targeting)) {

                            exports.setTargeting(container, targeting);
                            exports.display(container);
                            exports.refresh(container);

                        }

                    }

                }

                return !inThreshold;

            });

        });

    };

    /**
     *
     * @method responsiveInit
     *
     */
    exports.responsiveInit = function() {

        currentThreshold = getThreshold($WINDOW.width());

        exports.responsiveRefresh();

        /**
         *
         * @event resize
         *
         */
        $WINDOW.on('resize', function() {

            var threshold = getThreshold($WINDOW.width());

            if (threshold !== currentThreshold) {
                currentThreshold = threshold;
                exports.responsiveRefresh();
            }

        });

    };

    /**
     *
     * @method queue
     * @param {Function} JsFunction
     *
     */
    exports.queue = function(JsFunction) {

        window.googletag.cmd.push(JsFunction);

    };

    /**
     *
     * @method enableSingleRequest
     *
     */
    exports.enableSingleRequest = function() {

        exports.queue(function() {
            window.googletag.pubads().enableSingleRequest();
        });

    };

    /**
     *
     * @method defineOutOfPageSlot
     * @param {Object} outOfPageSlot
     *
     */
    exports.defineOutOfPageSlot = function(outOfPageSlot) {

        var container = outOfPageSlot.container,
            targeting = outOfPageSlot.targeting,
            slotUnit  = UNITNAME;

        if (outOfPageSlot.inventoryHierarchy) {
            slotUnit = getDefaultInventoryHierachy() + outOfPageSlot.inventoryHierarchy;
        }

        exports.queue(function() {

            window.gptadslots[container] = window.googletag.defineOutOfPageSlot(slotUnit, container).addService(window.googletag.pubads());

            exports.setTargeting(container, targeting);

        });

    };

    /**
     *
     * @method defineSlot
     * @param {Object} slot
     *
     */
    exports.defineSlot = function(slot) {

        var defaultTargeting = DEFAULTS.targeting,
            container = slot.container,
            sizes = slot.sizes,
            targeting = $.extend({}, slot.targeting, defaultTargeting),
            slotUnit = UNITNAME;

        if (slot.inventoryHierarchy) {
            slotUnit = getDefaultInventoryHierachy() + slot.inventoryHierarchy;
        }

        exports.queue(function() {

            window.gptadslots[container] = window.googletag.defineSlot(slotUnit, sizes, container).addService(window.googletag.pubads());

            exports.setTargeting(container, targeting);

        });

    };

    /**
     *
     * @method defineAndDisplaySlot
     * @param {Object} slot
     *
     */
    exports.defineAndDisplaySlot = function(slot) {

        var container = slot.container,
            sizes = slot.sizes,
            slotUnit = UNITNAME;

        if (slot.inventoryHierarchy) {
            slotUnit = getDefaultInventoryHierachy() + slot.inventoryHierarchy;
        }

        window.gptadslots[container] = window.googletag.pubads().display(slotUnit, sizes, container);

    };

    /**
     *
     * @method setPageTargeting
     * @param {Object} targeting
     *
     */
    exports.setPageTargeting = function(targeting) {
        exports.queue(function(){
            for (var key in targeting) {
                    if (targeting.hasOwnProperty(key)) {
                        var pubads = window.googletag.pubads();
                        exports.queue(pubads.setTargeting.bind(pubads, key, targeting[key]));
                    }
            }
        });

    };

    /**
     *
     * @method setTargeting
     * @param {String} container
     * @param {Object} targeting
     * @description extends targeting Object with the required activeSponsorship Object,
     * passes data off to gptadslots
     *
     */
    exports.setTargeting = function(container, targeting) {

        targeting = $.extend({}, targeting, activeSponsorship.adSlotTargeting(container));

        // console.log(container);
        // console.log(targeting);

        for (var key in targeting) {
            if (targeting.hasOwnProperty(key)) {
                exports.queue(window.gptadslots[container].setTargeting.bind(window.gptadslots[container], key, targeting[key]));
            }
        }

    };

    /**
     *
     * @method enableServices
     *
     */
    exports.enableServices = function() {

        exports.queue(function() {
            window.googletag.enableServices();
        });

    };

    /**
     *
     * @method display
     * @param {String} container
     *
     */
    exports.display = function(container) {

        document.getElementById(container).style.display = 'block';

        exports.queue(function() {
            window.googletag.display(container);
        });

    };

    /**
     *
     * @method refresh
     * @param {Array|String} ads
     *
     */
    exports.refresh = function(ads) {

        var refreshedAds = ensureArray(ads),
            pubService = window.googletag.pubads(),
            slots = [];

        for (var i = 0; i < refreshedAds.length; i++) {
            slots.push(window.gptadslots[refreshedAds[i]]);
        }

        pubService.refresh(slots);

    };

    /**
     *
     * @method init
     * @param {Object} config
     *
     */
    exports.init = function(config) {

        $.extend(DEFAULTS, config);

        $SKIN = $(DEFAULTS.skinElement);
        UNITNAME = DEFAULTS.networkId + DEFAULTS.inventoryHierarchy;

        // request all ads in single request
        if (DEFAULTS.enableSingleRequest) {
            exports.enableSingleRequest();
        }

        // define the optional Out of Page slot, used for interstitials and takeovers
        if (DEFAULTS.hasOwnProperty('outOfPageAd')) {
            exports.defineOutOfPageSlot(DEFAULTS.outOfPageAd);
        }

        // define the ad slots passed to init config
        if (DEFAULTS.hasOwnProperty('ads')) {
            for (var def = 0; def < DEFAULTS.ads.length; def++) {
                exports.defineSlot(DEFAULTS.ads[def]);
            }
        }

        // set DeviceType to all slots
        if (window.DeviceType) {
            exports.setPageTargeting({
                'devicetype': window.DeviceType.device
            });
        }

        // adds query param ('adtest') driven key/val to all slots for testing
        if (!!ADOPSTEST) {
            exports.setPageTargeting({
                'adtest': ADOPSTEST
            });
        }

        exports.enableServices();

        // display the optional Out of Page slot
        if (DEFAULTS.hasOwnProperty('outOfPageAd')) {
            exports.display(DEFAULTS.outOfPageAd.container);
        }

        // display the ad slots passed to init config
        if (DEFAULTS.hasOwnProperty('ads')) {
            for (var dis = 0; dis < DEFAULTS.ads.length; dis++) {
                exports.display(DEFAULTS.ads[dis].container);
            }
        }

        // init responsive mode if enabled
        if (DEFAULTS.responsive) {
            exports.responsiveInit();
        }

    };

});

